import React from 'react';
import { IArticle } from '../types';

// eslint-disable-next-line @typescript-eslint/naming-convention
const chto_takoe_operator_reklamnih_dannih: IArticle = {
  title: 'Что такое оператор рекламных данных и как маркировать рекламу в ОРД',
  image: '/assets/img/blog/chto_takoe_operator_reklamnih_dannih.jpeg',
  prewievImage:
    '/assets/img/blog/chto_takoe_operator_reklamnih_dannih-prewiev.jpeg',
  content: [
    {
      text: [
        '1 сентября 2022 года в России были приняты поправки к Закону "О рекламе" (№38-ФЗ), согласно статье 18.1 Закона вся интернет-реклама на территории РФ должна быть промаркирована.',
        <>
          Для исполнения статей Закона был сформирован ЕРИР (Единый реестр
          интернет-рекламы), подконтрольный орган Роскомнадзора, отвечающий за
          регистрацию всей интернет-рекламы в РФ. ЕРИР обеспечивает прозрачность
          и контроль над рекламной деятельностью в интернете. Подробнее о ЕРИР в
          нашем материале{' '}
          <a href="/blog/chto_takoe_erir">
            «Что такое ЕРИР и его роль в маркировке интернет-рекламы»
          </a>
          .
        </>,
        'Изменения в законодательстве обязали всех участников рекламного рынка маркировать рекламу и передавать данные об организаторах, креативах и статистике показов в ЕРИР. Посредником между рекламодателями и ЕРИР были определены ОРД (операторы рекламных данных). В данной статье мы раскроем назначение ОРД и порядок работы с ними.',
      ],
    },
    {
      subTitle: 'Что представляют собой ОРД?',
      text: [
        'ОРД – оператор рекламных данных – структура, аккредитованная Роскомнадзором, IT платформа, на которой можно получить рекламный маркер и передать сведения о рекламе для их последующей отправки в ЕРИР. Напрямую данные в ЕРИР передать нельзя, ОРД как раз и являются специальной площадкой, принимающими эти данные, обрабатывающими и передающими в ЕРИР.',
      ],
    },
    {
      subTitle: 'Какие функции выполняет ОРД',
      text: [
        'Операторы рекламных данных (ОРД) занимаются сбором, обработкой и передачей информации о рекламных кампаниях в ЕРИР. ОРД аккумулируют рекламные данные, обеспечивая прозрачность в сфере интернет-рекламы, позволяя государственным органам (таким как Роскомнадзор, ФАС и ФНС) следить за исполнением законодательства, контролировать финансовые потоки в рекламных цепочках, собирать статистику по рекламе, необходимую для государственного регулирования.',
      ],
    },
    {
      subTitle: 'Кто может передавать данные в ОРД?',
      text: [
        'Работать с ОРД может любой участник рекламной цепочки (физические и юридические лица), в том числе третьи лица (например: независимые агентства и фрилансеры, предоставляющие услуги по маркировке рекламы).',
        <strong>Кто относится к участникам рекламной цепочки:</strong>,
        <ul>
          <li>
            <strong>Рекламодатель (РД)</strong> - лицо, определяющее объект
            рекламирования, заказывающее и оплачивающее рекламу с таргетингом на
            РФ. Рекламодатель является первым звеном рекламной цепочки и может
            делегировать ответственность по рекламе другим участникам
          </li>
          <li>
            <strong>Рекламораспространитель (РР)</strong> - владелец рекламной
            площадки, где размещается реклама. Рекламораспространителями также
            являются блогеры, которые размещают рекламные посты. Это последнее
            звено в рекламной цепочке (перед ОРД)
          </li>
          <li>
            <strong>Рекламное агентство (РА)</strong> - Юридическое лицо,
            которое разрабатывает / создает и размещает рекламу
          </li>
          <li>
            <strong>Оператор рекламной системы (ОРС)</strong> - владелец
            рекламной системы, посредством которой распространяется реклама
          </li>
        </ul>,
      ],
    },
    {
      subTitle: 'Кто отвечает за маркировку рекламы и передачу данных',
      text: [
        <>
          <strong>
            Законом не запрещается делегирование прав на передачу данных о
            рекламе третьим лицам
          </strong>
          , не участвующим в рекламной цепочке (процессе создания и размещения
          рекламы). Третьими лицами могут быть физические и юридические лица,
          предоставляющие услуги по маркировке рекламы.
        </>,
        'Важным дополнением здесь будет тот факт, что ответственность за передачу данных в ОРД Рекламодатель может возложить на одного из участников капании по договору. Но данный пункт должен быть обязательно прописан в договоре. В случае недобросовестного исполнения обязательств по маркировке рекламы и непредоставлению отчётности в ОРД, ответственность за неисполнение норм Закона понесёт рекламодатель. Но рекламодатель может передать юридическую ответственность. Это означает, что административную ответственность за несоблюдение Закона понесёт сторона, отвечающая по договору за маркировку.',
        <>
          Подробно об ответственности и размерах штрафов за отсутствие
          маркировки мы писали в статье{' '}
          <a href="/blog/otvetstvennost_za_shtrafi">
            «Ответственность и штрафы за отсутствие маркировки рекламы в
            интернете»
          </a>
          .
        </>,
      ],
    },
    {
      subTitle: 'Как начать работу с ОРД',
      text: [
        <ol>
          <li>
            <strong>Первый шаг.</strong> Для того, чтобы получить рекламный
            маркер и начать передавать данные о рекламе для начала необходимо
            зарегистрироваться на сайте ОРД от SberAds. <br />
            После регистрации к вам на электронную почту придёт письмо с
            подтверждением регистрации и ссылкой для перехода на сайт ОРД.
          </li>
          <li>
            <strong>Вторым шагом</strong> мы предлагаем вам протестировать
            работу в личном кабинете и попробовать свои силы в маркировке
            рекламы, не передавая данные в ЕРИР. Для данных целей на сайте
            существует «песочница» Sandbox - специально созданное пространство,
            которой полностью дублирует функционал промышленной / рабочей среды.
          </li>
          <li>
            <strong>Третьим шагом</strong>, для получения доступа к промышленной
            среде, вам необходимо в специальном окне выбрать тип вашей
            организации и прикрепить требуемые документы. <br />
            Для юридических лиц: <br />
            <ul>
              <li>Устав</li>
              <li>Карточка организации</li>
              <li>Протокол об избрании единоличного исполнительного органа</li>
              <li>Доверенность (если необходимо)</li>
              <li>Свидетельство о постановке на учет в налоговом органе</li>
            </ul>
            Для индивидуальных предпринимателей: <br />
            <ul>
              <li>Карточка с реквизитами</li>
              <li>
                Свидетельство о государственной регистрации индивидуального
                предпринимателя (ОГРНИП)
              </li>
              <li>Свидетельство о постановке на налоговый учёт (ИНН)</li>
              <li>Паспорт (страницы с фото и регистрацией)</li>
            </ul>
            Прикреплённые документы отправляются на проверку, которая занимает
            1-2 (рабочих) дня, без учёта выходных.
          </li>
          <li>
            <strong>Четвёртый шаг.</strong> Если документы в порядке, вам на
            почту придёт уведомление о том, что документы прошли проверку и вам
            предоставлен доступ в Промышленную среду. Чтобы начать работу вам
            останется только принять оферту.
          </li>
          <li>
            <strong>Пятый шаг.</strong> Приняв оферту, вы можете приступить к
            работе в Личном кабинете ОРД от SberAds.
          </li>
        </ol>,
        <>
          Вся регистрация на сайте и заполнение первичной информации для начала
          работы с ОРД занимает не более 15 минут. Здесь вы можете посмотреть
          видео-инструкцию{' '}
          <a href="/webinars?tab=lessons">«Как зарегистрироваться в ОРД»</a>.
        </>,
      ],
    },
    {
      subTitle: 'Разделы Личного кабинета ОРД:',
      text: [
        <ol>
          <li>
            <strong>Организации</strong>
            <br />В данном разделе вы заполняете информацию об организациях,
            участвующих в рекламной кампании.
          </li>
          <li>
            <strong>Площадки</strong>
            <br />
            Этот раздел предназначен для регистрации Площадок, на которых
            планируется размещение рекламы. Площадка – это веб-ресурс (сайт),
            аккаунт в социальной сети или мобильное приложение.
          </li>
          <li>
            <strong>Договоры</strong>
            <br />В этом разделе вы указываете данные по Договорам, которые
            сопровождают рекламные кампании.
          </li>
          <li>
            <strong>Креативы</strong>
            <br />В разделе Креативы вы прикрепляете графические или видео файлы
            рекламных публикаций, если они есть, а также тексты рекламных
            сообщений и вносите данные о формате. Именно в этом разделе
            пользователь получает рекламный маркер (erid), который затем
            указывается в публикациях.
          </li>
          <li>
            <strong>Акты</strong>
            <br />В разделе Акты прикрепляются Акты по Договорам и указываются
            роли Заказчика и Исполнителя (рекламное агентство, рекламодатель,
            оператор рекламной системы, рекламораспространитель). Акты
            документируют факт выполненных работ по ведению рекламных кампаний.
          </li>
          <li>
            <strong>Статистика показов</strong>
            <br />
            Данный раздел предназначен для передачи отчётности по рекламе.
            Согласно предписаниям Роскомнадзора, в течение 30 дней после
            окончания месяца, в котором были показы рекламы (даже, если
            размещение еще не закончено), данные о количестве показов и
            площадках (сайты, социальные сети), на которых реклама размещалась,
            должны быть переданы в ЕРИР.
          </li>
          <li>
            <strong>Массовые загрузки</strong>
            <br />
            Если вам необходимо загрузить сразу несколько объектов (организации,
            договора, акты, креативы, статистика), то можно воспользоваться
            функционалом Массовой загрузки. Этот раздел предназначен в основном
            для рекламных агентств, передающих большие объёмы информации, и
            позволяет существенно упростить работу.
          </li>
          <li>
            <strong>Заявки на удаление</strong>
            <br />
            Если вы ввели ошибочные данные или задублировали информацию, то
            создать заявку на удаление можно на странице самого объекта, а в
            разделе «Заявки на удаление» отслеживать статус.
          </li>
          <li>
            <strong>Отчёты</strong>
            <br />
            Раздел создан, чтобы пользователь мог посмотреть статусы по своим
            объектам (Утверждено / Отклонено). Данный раздел содержит:
            <ul>
              <li>Отчёт об услугах</li>
              <li>Отчёт о регистрации объектов</li>
              <li>Отчёт о количестве объектов</li>
            </ul>
          </li>
          <li>
            <strong>Ключи</strong>
            <br />
            Это краткий обзор разделов Личного кабинета ОРД. Подробная
            инструкция о работе в Личном кабинете находится в разделе{' '}
            <a href="/documentation">Документация</a>. Также ОРД от SberAds
            регулярно проводит открытые{' '}
            <a href="/webinars?tab=webinars">вебинары</a> для новых
            пользователей. Существуют и{' '}
            <a href="/webinars?tab=lessons">видео-инструкции</a> по работе с
            разделами: о том, как внести данные об организации, как прикрепить
            акты и передать отчёты по рекламным кампаниям. Всё это можно найти в
            обширной <a href="/knowledge-base">Базе знаний</a>. А если останутся
            вопросы, то всегда можно обратиться за помощью в службу клиентской
            поддержки на info@ord-lab.ru.
          </li>
        </ol>,
      ],
    },
    {
      subTitle: 'Заключение',
      text: [
        'ОРД занимают важное место в выполнении требований законодательства о рекламе в России. Операторы рекламных данных отвечают за сбор, обработку и передачу информации о рекламных кампаниях в ЕРИР, что дает возможность государственным структурам контролировать рынок рекламы.',
        'Для всех участников рекламного рынка крайне важно своевременно подавать отчетность в ОРД, чтобы избежать возможных штрафных санкций. Ответственное отношение к маркировке рекламы участниками процесса, в свою очередь, будет способствовать увеличению прозрачности и законности интернет-рекламы в России.',
      ],
    },
  ],
};

export default chto_takoe_operator_reklamnih_dannih;
